enum BrowserAgent {
  OPERA_AGENT = 'OP',
  CHROME_AGENT = 'Chrome',
  EDGE_AGENT = 'Edg',
  FIREFOX_AGENT = 'Firefox',
  UNKNOWN = 'Unknown',
}

export const getBrowserAgent = () => {
  const userAgentString = navigator.userAgent;

  if (userAgentString.indexOf(BrowserAgent.OPERA_AGENT) > -1) {
    return BrowserAgent.OPERA_AGENT;
  }
  if (userAgentString.indexOf(BrowserAgent.EDGE_AGENT) > -1) {
    return BrowserAgent.EDGE_AGENT;
  }
  if (userAgentString.indexOf(BrowserAgent.FIREFOX_AGENT) > -1) {
    return BrowserAgent.FIREFOX_AGENT;
  }
  if (userAgentString.indexOf(BrowserAgent.CHROME_AGENT) > -1) {
    return BrowserAgent.CHROME_AGENT;
  }
  return BrowserAgent.UNKNOWN;
};

export { BrowserAgent };
